
export * from './src/NhsTerminologyServerClient'

        import * as me from '@peachy/nhs-pure'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/nhs/pure'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/nhs-pure'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    